import {
    NAV_REQUEST,
    NAV_SUCCESS,
    NAV_FAILURE,
} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    navData: [],
    navDataLevel2Images :[],
    navDataLevel1Images :[],
    error: null,
};

export default function navReducer(state = initialState, action) {
    switch (action.type) {
        case NAV_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case NAV_SUCCESS:
            return {
                ...state,
                // always replacing data
                navData: action.data.category_data,
                navDataLevel1Images : action.data.level1_images,
                navDataLevel2Images : action.data.level2_images,

                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case NAV_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
}
